const floor = (num, ten = false) => {
  let pivot = 10 ** (num.toString().length - 1);
  return Math.floor(num / pivot) * pivot;
};

export const nearestTen = { floor };
